module.exports = __webpack_public_path__ + "img/healthdata.01607c60.png";